function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Label from '../common/form/Label.react';
import Button from '../common/Button.react';
import AddImage from '../common/assets/add-image/AddImage.button';
var PpcClientLogo = function PpcClientLogo(_ref) {
  var client = _ref.client;
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var hasPermission = useHasPermission("edit-".concat(app, "-associations"));
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    setState(client);
  }, [client]);
  var clientID = state._id,
    imageColor = state.imageColor,
    imageGray = state.imageGray;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Logo"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: "associations-logo"
  }, (imageColor === null || imageColor === void 0 ? void 0 : imageColor.filename) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(bucket, "/").concat(imageColor === null || imageColor === void 0 ? void 0 : imageColor.filename)
  })), hasPermission && !(imageColor !== null && imageColor !== void 0 && imageColor.filename) && /*#__PURE__*/React.createElement(AddImage, {
    blobType: "ppcAssociationLogo",
    onSelect: function onSelect(asset) {
      dispatch({
        type: ppcActions.clients,
        payload: {
          formData: {
            clientID: clientID,
            assetID: asset._id,
            imageType: 'imageColor',
            apiID: 'add-image-button'
          },
          method: 'put',
          route: 'image'
        }
      });
    }
  }), hasPermission && (imageColor === null || imageColor === void 0 ? void 0 : imageColor.filename) && /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    apiID: "del-image",
    requireConfirmation: true,
    onClick: function onClick() {
      dispatch({
        type: ppcActions.clients,
        payload: {
          formData: {
            clientID: clientID,
            imageType: 'imageColor',
            apiID: 'del-image'
          },
          method: 'delete',
          route: 'image'
        }
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 40
    }
  }))));
};
export default PpcClientLogo;